import {
  createApi,
} from "@reduxjs/toolkit/query/react";
import { baseQueryWithErrorHandling } from "./API";

const el: any = document.querySelector("#app");
export const { contactsClientId, apiBase, csrfToken } = JSON.parse(
  el?.dataset?.page ?? ""
).props;

export type HelpResponseData = {
  id: string;
  intro: string;
  more: string;
  slug: string;
};

// localhost:8000
export const knowledgeBaseAPI = createApi({
  reducerPath: "knowledgeBaseAPI",
  baseQuery: baseQueryWithErrorHandling({
    baseUrl: `https://help.uatboomcomms.com/api`,
  }),
  // refetchOnMountOrArgChange: true,
  tagTypes: [],
  endpoints: (builder) => ({
    getHelpContent: builder.query<HelpResponseData, string>({
      query: (id) => id,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetHelpContentQuery } = knowledgeBaseAPI;
